import { Actions } from '@ngrx/effects';
import { BaseResourceEffects } from '../base-resource.effects';
import { meetingAvailabilityActions } from './meeting-availability.actions';
import { MeetingAvailabilityService } from '../../services/meeting-availability.service';
import { CoreAppState } from '../core-app.state';
import { Injectable } from '@angular/core';
import { selectMeetingAvailabilityState } from './meeting-availability.reducer';
import { Store } from '@ngrx/store';
import { MeetingAvailabilityResourceTypeMappings } from '@aa/nest/resource';

@Injectable()
export class MeetingAvailabilityEffects extends BaseResourceEffects<MeetingAvailabilityResourceTypeMappings> {
  constructor(
    protected override readonly actions$: Actions,
    protected override readonly store: Store<CoreAppState>,
    protected override readonly service: MeetingAvailabilityService,
  ) {
    super(
      actions$,
      store,
      service,
      meetingAvailabilityActions,
      selectMeetingAvailabilityState,
    );
  }
}
